module.exports = __webpack_public_path__ + "img/beer-mug.30273939.svg";